// Marketplace/preview surfaces show at most this many screenshots per app.
const APP_SCREENSHOTS_SHOWN = 4;

/**
 * The screenshots shown for an app
 * @param {object} app
 * @param {number} [number] how many to return; defaults to
 *   `APP_SCREENSHOTS_SHOWN`. Pass 0 explicitly to return all of them
 * @returns {Array<{ id: string, file: object, title?: string }>}
 */
function getAppScreenshots(app, number = APP_SCREENSHOTS_SHOWN) {
  const assets = Array.isArray(app?.image_assets) ? app.image_assets : [];
  const declaredImages = Array.isArray(app?.images) ? app.images : [];

  return (number ? declaredImages.slice(0, number) : declaredImages)
    .map((declared) => {
      const asset = assets.find((asset) => asset?.id === declared?.id);
      const file = asset?.image || asset?.file;

      if (!file) {
        return null;
      }

      return {
        id: declared.id,
        file,
        ...(declared?.title ? { title: declared.title } : {}),
      };
    })
    .filter(Boolean);
}

module.exports = {
  APP_SCREENSHOTS_SHOWN,
  getAppScreenshots,
};
